import { Component, OnInit, Input, SimpleChange, ViewChild } from '@angular/core';
import { CatalogService, AuthenticationService, HeaderService, UtilsService } from 'src/app/_services';
import { Product, User, Carrusel, Category, CategoriesTree } from 'src/app/_models'
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ApplicationStateService } from 'src/app/_services/application-state.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductFormatOptionsModalComponent } from '../product-format-options-modal/product-format-options-modal.component';
import { ProductBatchModalComponent } from '../product-batch-modal/product-batch-modal.component';


declare const $ : any ;

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css'],
})

export class ProductListComponent implements OnInit {
  
  public products :Product[] = [];  
  public currentUser : User;
  public orderByForm : FormGroup;
  public pageSize : number;
  public scrolling : boolean ;

  @ViewChild(ProductFormatOptionsModalComponent) formatOptionsModal: ProductFormatOptionsModalComponent; 
  @ViewChild(ProductBatchModalComponent) batchModal: ProductBatchModalComponent; 


  @Input() featured : boolean = false;
  @Input() query : string = '';
  @Input() categoryId : string = '';
  
  public orderBy : string = '';
  public filters : Map<string, string[]> = new Map();
  public categoryBanner : Observable<Carrusel> = null;

  public rnd : number;

  public get filtered() : boolean  {
      let filtered : boolean = false;

      this.filters.forEach( e => {
        filtered = filtered || e.length  > 0;
      });
      this.catalog.filtered = filtered;
      return filtered;
  }

  public get withFilters() : boolean {
    return this.catalog.currentCategory != null || this.query.trim() != '';
  }

    constructor(
    private auth : AuthenticationService,
    private formBuilder : FormBuilder,
    public router : Router,
    public catalog : CatalogService,
    public translate : TranslateService,
    public dom : DomSanitizer,
    public apps : ApplicationStateService,
    public header : HeaderService,
    public utils: UtilsService,
    private spinner : NgxSpinnerService,
    private titles : Title
  ) { 
    
    this.auth.currentUser.subscribe( currentUser  => {
        this.currentUser = currentUser;
        this.products = this.products.slice(0,0);
        this.catalog.currentCategory = null;
        this.catalog.filtered = false;
        this.initFilters();
        this.loadData();
      });
  }

  ngOnInit() {

    this.orderByForm = this.formBuilder.group({
      orderBy :[this.orderBy]
    });

    this.scrolling = false;
  }
  
  onOrderBy(){
    this.orderBy = this.orderByForm.controls.orderBy.value;
    sessionStorage.setItem("oderBy",this.orderBy);
    this.products = [];
    this.loadData();
    this.header.scrollMain();
  }

  onOrderByKey(key : string){
    this.orderBy = key;
    sessionStorage.setItem("oderBy",this.orderBy);
    this.products = [];
    this.loadData();
    this.header.scrollMain();
  }


  ngOnChanges() {
    this.products = [];
    this.initFilters();
    
    if ( this.categoryId  ){

      this.pageSize = environment.CATALOG.PAGE_SIZE;
      this.featured = false;
      this.categoryBanner = null;

      this.catalog.getTree(this.auth.isLogedUser).subscribe(tree => {
        // Elimina ordenació si hi ha canvi de categoria
        if (this.catalog.currentCategory){
          if (this.catalog.currentCategory.id !=  this.categoryId){
            this.orderBy = '';
            sessionStorage.setItem('oderBy','');
          }
        }
        this.catalog.currentCategory =  this.catalog.Tree.getCategory(this.categoryId);
        if (this.catalog.currentCategory == null) {      
            // this.router.navigate(['/error404']);
            this.catalog.getCategory(this.categoryId).subscribe( result =>{
              this.catalog.currentCategory = result;
              this.loadData();
            });
        } else {
          this.loadData();
        }
      });

    }  else if (this.query != '') {
      this.pageSize = environment.CATALOG.PAGE_SIZE;
      this.catalog.currentCategory = null;
      this.categoryBanner = null;
      this.loadData();
    }
    else {
      this.pageSize = environment.CATALOG.HOME_PAGE_SIZE;
      this.catalog.currentCategory = null;    
      this.loadData();
    }

    this.header.scrollTop();
    
  }

  loadData(filtering? : boolean) {

    if (this.catalog.currentCategory){
      if (this.catalog.currentCategory.banner_id){
        this.categoryBanner = this.utils.getCarrusel(this.catalog.currentCategory.banner_id, this.translate.currentLang);
      }
  
      this.translate.onLangChange.subscribe( params => {
        if (this.catalog.currentCategory.banner_id){
          this.categoryBanner = this.utils.getCarrusel(this.catalog.currentCategory.banner_id, this.translate.currentLang);
        }
      }); 
    }
    
    const categoryId = this.catalog.currentCategory ? this.catalog.currentCategory.id : null;

    let index = this.products.length;

    if (filtering){
      index = 0;
    } else {
      setTimeout(() => {
        this.spinner.show();  
      }, environment.READY_TIMEOUT);
    }

    if ( this.featured ){
      this.catalog.getHomeProducts (this.auth.isLogedUser, index , this.pageSize).subscribe( result =>  {

        this.translate.get('HOME_TITLE').subscribe(translation =>{
          this.titles.setTitle(translation);
        });

        this.products = result;
        setTimeout(() => {
          this.spinner.hide();  
        }, environment.READY_TIMEOUT);       
      } ,error=> {
        setTimeout(() => {
          this.spinner.hide();  
        }, environment.READY_TIMEOUT);
      });
    }
    else {
      this.catalog.get(categoryId, this.filters,  this.orderBy, this.query, index , this.pageSize, filtering).subscribe( result =>  {
        if (this.catalog.currentCategory){
          const bread = this.catalog.currentCategory.getBreadCrumbs();
          let title : string = '';

          bread.forEach(bread =>{
            title = title + ' - ' + bread.getText(this.translate.currentLang) ;
          });
          
          this.translate.get('CATALOG_TITLE', {title : title }).subscribe( translation => {
            this.titles.setTitle(translation);
          });
        }

        this.products = result;
        setTimeout(() => {
          this.spinner.hide();  
        }, environment.READY_TIMEOUT);

      } ,error=> {
        this.query = '';
        setTimeout(() => {
          this.spinner.hide();  
        }, environment.READY_TIMEOUT);

      });
    }

  }
    
  onScrollDown () {
    if (!this.catalog.searching){

      setTimeout(() => {
        this.spinner.show();  
      }, environment.READY_TIMEOUT);

      this.scrolling = true;

      if (this.featured){
        this.catalog.getHomeProducts (this.auth.isLogedUser, this.products.length , this.pageSize).subscribe(  result => {
          this.products = this.products.concat(result);
          this.scrolling = false;
          setTimeout(() => {
            this.spinner.hide();  
          }, environment.READY_TIMEOUT);
  
        });
      } else   {
        const  categoryId : string = this.catalog.currentCategory  ? this.catalog.currentCategory.id : '' ;
        this.catalog.get(categoryId, this.filters, this.orderBy, this.query, this.products.length, this.pageSize, false).subscribe( result =>  {
          this.products = this.products.concat(result);
          this.scrolling = false;
          setTimeout(() => {
            this.spinner.hide();  
          }, environment.READY_TIMEOUT); 
        });
      } 

    }
  }


  onRemoveFilters (){
    //this.products = this.products.slice(0,0);
    this.initFilters();
    this.loadData(true);
    this.catalog.filtered = this.filtered;
    this.header.scrollMain();
  }

  onRemoveFilter (filterType : string){
    //this.products = this.products.slice(0,0);
    this.filters.set(filterType, this.filters.get(filterType).slice(0,0));
    this.loadData(true);
    this.catalog.filtered = this.filtered;
    this.header.scrollMain();
  }

  onFilter (filterType : string, brand : string){
    // this.products = this.products.slice(0,0);

    let remove : boolean;
    remove = this.isFiltered(filterType,brand);
    this.filters.set(filterType, this.filters.get(filterType).slice(0,0));
    if (! remove) {
      this.filters.get(filterType).push(brand)
    }

    this.loadData(true);
    this.catalog.filtered = this.filtered;
    this.header.scrollMain();
  }

  get filterCount(): number {
    let count : number = 0;
    this.filters.forEach(f => {
      count += f.length;
    });
    return count;
  }

  filteredBy(filterType : string): boolean {
    return this.filters.get(filterType).length > 0;
  }

  isFiltered(filterType : string, name : string): boolean {
    return this.filters.get(filterType).indexOf(name) > -1;
  }

  initFilters(){

    if (sessionStorage.getItem("oderBy") != null ){
      this.orderBy = sessionStorage.getItem("oderBy");
    }

    this.filters.set('BRAND', []);
    this.filters.set('CHARACTERISTIC', []);
    this.filters.set('OFFER', []);
    this.filters.set('TIPOLOGY', []);
    this.catalog.filtered = this.filtered;
  }

}
